export const iconFontAwesomeTextformattingBorderNone = (
	<i className="fa-solid fa-border-none"></i>
);
